import classNames from "classnames";
import React from "react";
import styles from "./Spinner.module.scss";

export type SpinnerSize = "sm" | "md" | "lg";

type SpinnerProps = {
  size?: SpinnerSize;
  label?: string;
  className?: string;
};

function Spinner({ size = "md", label, className }: SpinnerProps) {
  return (
    <div className={classNames(styles.wrapper, className)} aria-live="polite">
      <span className={classNames(styles.spinner, styles[size])} aria-hidden="true" />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}

export default Spinner;
